import React from 'react'
import { Grid, Icon } from 'gu-ui-kit'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import styles from 'modules/Advertisers/List/subcomponents/StatusIcon/status-icon.module.scss'

const StatusIcon = ({ status }) => {
  return (
    <Grid
      alignItems={'center'}
      justifyContent={'center'}
      fluid={false}
      className={clsx(styles['container'], {
        [styles['container_' + status]]: status,
      })}
    >
      <Icon
        name={'user'}
        color={
          status === 'active' ? 'Accent-Confirm-Primary' : 'Interface-Eighth'
        }
        size={'m'}
      />
    </Grid>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['active', 'archived']),
  breakpoints: PropTypes.object,
}

export default StatusIcon
